import { defineMessages } from 'react-intl';

export default defineMessages({
    AddDriverPopupTitle: {
        id: 'ml.agent.quoteandbind.pa.controllers.MLPAPrefillDataCtrl.Add a new driver to your quote',
        defaultMessage: 'Add a new driver to your quote'
    },
    DOBTooltipContent: {
        id: 'ml.agent.quoteandbind.pa.controllers.MLPAPrefillDataCtrl.Date of Birth Tooltip Content',
        defaultMessage: 'We need this information to provide you an accurate quote.'
    },
    addDriverLabel: {
        id: 'ml.agent.quoteandbind.pa.controllers.MLPAPrefillDataCtrl.Add Driver',
        defaultMessage: 'Add Driver'
    },
    cancelLabel: {
        id: 'ml.agent.quoteandbind.pa.controllers.MLPAPrefillDataCtrl.Cancel',
        defaultMessage: 'Cancel'
    },
    stateLicenseOptional: {
        id: 'ml.agent.quoteandbind.pa.controllers.MLPAPrefillDataCtrl.stateLicenseOptional',
        defaultMessage: 'State Licensed (optional)'
    }
});
